"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasProfanity = exports.sanitizeProfanity = void 0;
const obscenity_1 = require("obscenity");
// Add extra words if any!
const extraWords = [];
const dataset = new obscenity_1.DataSet();
dataset.addAll(obscenity_1.englishDataset);
extraWords.forEach((item) => {
    dataset.addPhrase((phrase) => phrase.setMetadata({ originalWord: item }).addPattern((0, obscenity_1.pattern) `${item}`));
});
const built = dataset.build();
const matcher = new obscenity_1.RegExpMatcher({
    ...built,
    ...obscenity_1.englishRecommendedTransformers,
});
/**
 * Function to remove profanity words from string
 * @param {string} input string to refine
 * @param {string|null} replaceWith word to replace profanity word with.
 * @returns {string} Refined string
 */
const sanitizeProfanity = (input, replaceWith = "") => {
    const censor = new obscenity_1.TextCensor().setStrategy(() => replaceWith);
    const matches = matcher.getAllMatches(input);
    // remove extra spacing between, start and end of input.
    return censor
        .applyTo(input, matches)
        .replace(/\s{2,}/g, " ")
        .trim();
};
exports.sanitizeProfanity = sanitizeProfanity;
/**
 * To check whether sentence includes profanity word or not.
 * @param {string} input
 * @returns {boolean}
 */
const hasProfanity = (input) => matcher.hasMatch(input);
exports.hasProfanity = hasProfanity;
